var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-25"
  }, [_vm._v("Stok Retur Konsumen")]), _c('p', {
    staticClass: "text-body mb-0"
  }, [_vm._v(" Daftar barang retur konsumen yang masuk ke stok mobil. ")])]), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelectRetur"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelectRetur",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "5",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInputRetur"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInputRetur",
      "type": "search",
      "placeholder": "Cari nota / barang..."
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function click($event) {
        _vm.filter = '';
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "items": _vm.returs,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "filter": _vm.tableFilter,
      "filter-included-fields": _vm.filterOn
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(_ref) {
        var index = _ref.index;
        return [_vm._v(" " + _vm._s(++index) + " ")];
      }
    }, {
      key: "cell(no_kwitansi)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.no_kwitansi ? _c('span', [_vm._v(_vm._s(item.no_kwitansi))]) : _c('i', {
          staticClass: "text-danger"
        }, [_vm._v("Data Penjualan tidak ditemukan")])];
      }
    }, {
      key: "cell(barang)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.barang ? _c('span', [_vm._v(_vm._s(item.barang))]) : _c('i', {
          staticClass: "text-danger"
        }, [_vm._v("Barang tidak ditemukan")])];
      }
    }, {
      key: "cell(tanggal)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.humanDate(item.tanggal)) + " ")];
      }
    }, {
      key: "cell(satuan)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [item.satuan ? _c('span', [_vm._v(_vm._s(item.satuan))]) : _c('i', {
          staticClass: "text-danger"
        }, [_vm._v("Satuan tidak ditemukan")])];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center mt-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total " + _vm._s(_vm.totalRows) + " data")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }